<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="$modal.closeModal"
    >
      <header class="m-the-modal-header">
        <h5>ATENCIÓN</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>Los formatos de archivo permitidos son:</p>
        <ul class="a-list-clean display-flex-row-center flex-wrap margin-bottom-zero margin-top-xlarge">
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-word font-size-large margin-right-xsmall text-color-content-document-word"></i>
            <span class="font-weight-bold">doc</span>
          </li>
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-word font-size-large margin-right-xsmall text-color-content-document-word"></i>
            <span class="font-weight-bold">docx</span>
          </li>
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-image font-size-large margin-right-xsmall text-color-content-document"></i>
            <span class="font-weight-bold">gif</span>
          </li>
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-image font-size-large margin-right-xsmall text-color-content-document"></i>
            <span class="font-weight-bold">jpg</span>
          </li>
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-image font-size-large margin-right-xsmall text-color-content-document"></i>
            <span class="font-weight-bold">jpeg</span>
          </li>
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-pdf font-size-large margin-right-xsmall text-color-content-document-pdf"></i>
            <span class="font-weight-bold">pdf</span>
          </li>
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-image font-size-large margin-right-xsmall text-color-content-document"></i>
            <span class="font-weight-bold">png</span>
          </li>
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-powerpoint font-size-large margin-right-xsmall text-color-content-document-ppt"></i>
            <span class="font-weight-bold">ppt</span>
          </li>
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-powerpoint font-size-large margin-right-xsmall text-color-content-document-ppt"></i>
            <span class="font-weight-bold">pptx</span>
          </li>
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-alt font-size-large margin-right-xsmall text-color-content-document"></i>
            <span class="font-weight-bold">txt</span>
          </li>
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-excel font-size-large margin-right-xsmall text-color-content-document-excel"></i>
            <span class="font-weight-bold">xls</span>
          </li>
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-excel font-size-large margin-right-xsmall text-color-content-document-excel"></i>
            <span class="font-weight-bold">xlsx</span>
          </li>
          <li class="display-flex-row-center margin-bottom-medium margin-right-large">
            <i class="far fa-file-archive font-size-large margin-right-xsmall text-color-content-document"></i>
            <span class="font-weight-bold">zip</span>
          </li>
        </ul>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeContentEditorModalFileExtensionError',

  data () {
    return {
      buttonPrimary: {
        action: 'ENTENDIDO',
        class: 'a-button-assets-primary',
        sending: false,
        type: 'submit'
      }
    }
  }
}
</script>
